enum OrderItemStyle {
    /** 如果有多个商品信息，把商品信息合并到一列里面显示，如：商品1（红色）*1; 商品2（黑色）*2；商品3（白色） */
    JOINED = "JOINED",
    /** 每一个商品一行，分多列显示，如果商品有多个，只有第一行有订单信息，其他行订单信息（订单号、地址等）为空。 <p><b>默认为这种导出方式</b>。 */
    PER_ITEM_PER_LINE = "PER_ITEM_PER_LINE",
    /** 每一个商品一行，分多列显示，如果商品有多个，每一行都有一样的订单信息 */
    PER_ITEM_PER_LINE_WITH_ORDER_INFO = "PER_ITEM_PER_LINE_WITH_ORDER_INFO",
}

export default OrderItemStyle;
